// test1355
(1355 && 0);
